import React, { useCallback, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";

import moment from "moment";

import { withTranslation } from "react-i18next";

import { useMediaQuery } from "@mui/material";

import { FIRE_NOC_DETAILS } from "tagTypes";

import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";

import BaseTable from "Components/Common/BaseTable";
import BreadCrumb from "Components/Common/BreadCrumb";

import FireNocDetailFilter from "./FireNocDetailFilter";
import IFCRCertificatesDisplay from "./IFCRCertificatesDisplay";

const RECORDS_PER_PAGE = 10;

const FireNoc = ({ t }) => {
  const resetPageRef = useRef();

  const lg = useMediaQuery("(min-width: 768px) and (max-width: 1399px)");
  const md = useMediaQuery("(min-width: 576px) and (max-width: 767px)");
  const sm = useMediaQuery("(max-width: 575px)");

  const [query, setQuery] = useState({});
  const [isResetPageRegistered, setIsResetPageRegistered] = useState(false);

  const handleResetPage = useCallback(resetPageRef.current, [
    isResetPageRegistered,
  ]);

  const columns = [
    {
      title: "Building Name",
      field: "fireSafetyBuilding.name",
    },
    {
      title: "FSCA No.",
      field: "certificate.approvalNumber",
    },
    {
      title: "Date Of Issue",
      renderCell: ({ certificate }) =>
        moment(certificate?.dateOfIssue).isValid()
          ? convertUTCDateToLocalDate(certificate?.dateOfIssue).format(
              "DD-MM-YYYY"
            )
          : "N/A",
    },
    {
      title: "Due Date",
      renderCell: ({ certificate }) =>
        moment(certificate?.dueDate).isValid()
          ? convertUTCDateToLocalDate(certificate?.dueDate).format("DD-MM-YYYY")
          : "N/A",
    },
    {
      title: "IFCR",
      renderCell: ({ fscrCertificates }) => (
        <IFCRCertificatesDisplay certificates={fscrCertificates} />
      ),
      columnProps: { style: { width: "30%" } },
    },
  ];

  const serverSidePaginationConfig = useMemo(
    () => ({
      endpoint: "/building-information/fire-noc",
      tags: [FIRE_NOC_DETAILS],
      query,
    }),
    [query]
  );

  return (
    <div className="page-content h-100">
      <BreadCrumb title={t("Fire NOC")} />

      <FireNocDetailFilter setQuery={setQuery} resetPage={handleResetPage} />

      <BaseTable
        columns={columns}
        pageSize={RECORDS_PER_PAGE}
        paginationType="serverSide"
        serverSidePaginationConfig={serverSidePaginationConfig}
        registerResetPage={(cb) => {
          resetPageRef.current = cb;
          setIsResetPageRegistered((prev) => !prev);
        }}
        maxHeight={
          sm
            ? "calc(100vh - 400px)"
            : md
            ? "calc(100vh - 360px)"
            : lg
            ? "calc(100vh - 120px)"
            : "calc(100vh - 170px)"
        }
      />
    </div>
  );
};

FireNoc.prototype = {
  t: PropTypes.func,
};

export default withTranslation()(FireNoc);
